webpackJsonp([22],{

/***/ 2732:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _users = __webpack_require__(786);

var _general = __webpack_require__(113);

var _do_verify_email = __webpack_require__(2733);

var _do_verify_email2 = _interopRequireDefault(_do_verify_email);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var siteName = config.SiteName;

    return {
        siteName: siteName
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            verifyUserEmail: (0, _redux.bindActionCreators)(_users.verifyUserEmail, dispatch)
        }
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_do_verify_email2.default);

/***/ }),

/***/ 2733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _logo = __webpack_require__(851);

var _logo2 = _interopRequireDefault(_logo);

var _back_button = __webpack_require__(852);

var _back_button2 = _interopRequireDefault(_back_button);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DoVerifyEmail = function (_React$PureComponent) {
    (0, _inherits3.default)(DoVerifyEmail, _React$PureComponent);

    function DoVerifyEmail(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, DoVerifyEmail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DoVerifyEmail.__proto__ || (0, _getPrototypeOf2.default)(DoVerifyEmail)).call(this, props));

        _this.verifyEmail = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var verifyUserEmail, verify, serverError;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            verifyUserEmail = _this.props.actions.verifyUserEmail;
                            _context.next = 3;
                            return verifyUserEmail(new URLSearchParams(_this.props.location.search).get('token'));

                        case 3:
                            verify = _context.sent;


                            if (verify && verify.data) {
                                _browser_history.browserHistory.push('/login?extra=verified&email=' + encodeURIComponent(new URLSearchParams(_this.props.location.search).get('email')));
                            } else if (verify && verify.error) {
                                serverError = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'signup_user_completed.invalid_invite',
                                    defaultMessage: 'The invite link was invalid.  Please speak with your Administrator to receive an invitation.'
                                });

                                _this.setState({
                                    verifyStatus: 'failure',
                                    serverError: serverError
                                });
                            }

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));


        _this.state = {
            verifyStatus: 'pending',
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(DoVerifyEmail, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.verifyEmail();
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.verifyStatus !== 'failure') {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.serverError
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_back_button2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'signup-team__container' },
                        _react2.default.createElement('img', {
                            className: 'signup-team-logo',
                            src: _logo2.default
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'signup__content' },
                            _react2.default.createElement(
                                'h1',
                                null,
                                this.props.siteName
                            ),
                            _react2.default.createElement(
                                'h4',
                                { className: 'color--light' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'web.root.signup_info',
                                    defaultMessage: 'All team communication in one place, searchable and accessible anywhere'
                                })
                            ),
                            serverError
                        )
                    )
                )
            );
        }
    }]);
    return DoVerifyEmail;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

DoVerifyEmail.propTypes = {

    /**
     * Object with validation parameters given in link
     */
    location: _propTypes2.default.object.isRequired,

    /**
     * Title of the app or site.
     */
    siteName: _propTypes2.default.string,

    /*
     * Object with redux action creators
     */
    actions: _propTypes2.default.shape({

        /*
         * Action creator to verify the user's email
         */
        verifyUserEmail: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = DoVerifyEmail;


DoVerifyEmail.defaultProps = {
    location: {}
};

/***/ })

});


// WEBPACK FOOTER //
// 22.1e48eb24e76de266b014.js